import { useEffect, useState } from "react";
import * as THREE from "three";

/**
 * Scène 3D du Centrifuge-Laser — REÇUE du backend, jamais redéfinie ici.
 *
 * Voir docs/DOCTRINE_GEOMETRIE_CANONIQUE.md.
 *
 * ⚠️ Ce hook construisait auparavant sa propre disposition (sphères en
 * couronne de rayon 3, cubes de rayon 4). Le backend en avait deux autres :
 * `generate_frame()` et `generate_centrifuge_laser_system()`. Trois géométries
 * concurrentes portaient donc le même nom, et le tick serveur simulait un objet
 * que le navigateur n'affichait pas — ce qui rendait toute comparaison
 * serveur/navigateur dénuée de sens (écart mesuré : 2,18×).
 *
 * La géométrie canonique vient désormais de
 * `GET /api/geometry/centrifuge_laser/initial`, produite par `generator.py` :
 * un système à trois couches — couronne de sphères, couronne de cubes, centre
 * laser — avec inerties et couleurs propres. Le front la rend telle quelle.
 */
//: Anneau central tenant lieu de tore, en attendant `/initial`.
//:
//: ⚠️ Cet état initial valait `torus: null`, et `CentrifugeLaser3D` lit
//: `torus.major_radius` DÈS LE PREMIER RENDU. La page plantait donc
//: systématiquement à l'ouverture — même symptôme que `torus_spring`, même
//: cause : un état initial qui n'a pas la forme de l'état final.
const ANNEAU_PAR_DEFAUT = {
  major_radius: 1.2,
  minor_radius: 0.3,
  color: [0.0, 1.0, 1.0],
};

export default function useCentrifugeLaserVisualizer() {
  const [scene, setScene] = useState({
    spheres: [], cubes: [], torus: ANNEAU_PAR_DEFAUT,
  });

  useEffect(() => {
    const controller = new AbortController();

    fetch("/api/geometry/centrifuge_laser/initial", { signal: controller.signal })
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then((data) => {
        if (!data || !Array.isArray(data.spheres) || !Array.isArray(data.cubes)) {
          throw new Error("réponse /initial invalide");
        }

        setScene({
          spheres: data.spheres.map((s) => ({
            position: new THREE.Vector3(...s.position),
            radius: s.radius ?? 0.5,
            color: s.color ?? [1, 1, 1],
          })),
          cubes: data.cubes.map((c) => ({
            position: new THREE.Vector3(...c.position),
            size: c.size ?? 0.6,
            color: c.color ?? [1, 1, 1],
          })),
          // Le centre laser tient lieu de tore central.
          torus: {
            ...ANNEAU_PAR_DEFAUT,
            color: data.laser_center?.color ?? ANNEAU_PAR_DEFAUT.color,
          },
        });
      })
      .catch((err) => {
        if (err.name !== "AbortError") {
          console.error("Erreur /initial centrifuge_laser:", err);
        }
      });

    return () => controller.abort();
  }, []);

  return scene;
}
